import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import orderBy from 'lodash/orderBy';
import { capacityDisplayLogic } from 'shared/helpers';
import { Accordion } from 'shared/components';

import './AssignedCountsCapacities.scss';

const AssignedCounsCapacities = ({ locations, capacityTypes }) => {
  const { t } = useTranslation();
  return (
    <section className="assigned-counts-capacities-section border-box-radius">
      <h5>{t('staffAndRoomsManagement.assignedCountsTitle')}</h5>
      <div className="delimiter"></div>
      {locations.length ? (
        <Accordion startPosition={0} className="border-box-row" siblingOpen>
          {orderBy(locations, 'name', 'asc').map((location, idx) => (
            <div
              key={`location-${idx}`}
              data-trigger={
                <h6>
                  {location.name}
                  {location.area && location.area.length > 0 && `, ${location.area}`}
                </h6>
              }>
              {orderBy(capacityTypes, 'displayOrder', 'asc').map(
                (type) =>
                  capacityDisplayLogic(location, type) && (
                    <div key={`type-${idx}-${type.id}`} className="type-row">
                      <span className="fw-bold"> {type.name} </span>
                      <span>{capacityDisplayLogic(location, type)}</span>
                    </div>
                  )
              )}
            </div>
          ))}
        </Accordion>
      ) : (
        <p>{t('testCenter.eventDashboard.noLocationsLabel')}</p>
      )}
    </section>
  );
};

export default AssignedCounsCapacities;

AssignedCounsCapacities.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  createRoomFlag: PropTypes.bool,
};
